export const TRANSLATION_KEYS = {
    Heading: "settingPage.areaPage.deleteDialog.heading",
    SecondaryHeading: "settingPage.areaPage.deleteDialog.secondaryHeading",
    ConfirmText: "common.deleteText",
    DismissText: "common.dismissText"
};